import React from 'react';

const Loading = () => {
    return (
        <div>

            <h1 className='text-2xl text-center'>Loading...</h1>

        </div>
    );
};

export default Loading;